module.exports = __webpack_public_path__ + "static/media/file_icon.3f0a1f9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/file_icon.svg
// module id = 322
// module chunks = 2